import { ERROR_ACTION, WAIT_FOR_ACTION } from "redux-wait-for-action";

export const actionTypes = {
  AUDIT_ARCHIVE_GET_REQUEST: "AUDIT_ARCHIVE_GET_REQUEST",
  AUDIT_ARCHIVE_GET_FAILURE: "AUDIT_ARCHIVE_GET_FAILURE",
  AUDIT_ARCHIVE_GET_SUCCESS: "AUDIT_ARCHIVE_GET_SUCCESS",

  AUDIT_ARCHIVE_ITEM_SET: "AUDIT_ARCHIVE_ITEM_SET",
  AUDIT_ARCHIVE_SET: "AUDIT_ARCHIVES_SET",
  AUDIT_ARCHIVE_MERGE: "AUDIT_ARCHIVE_MERGE",
  AUDIT_ARCHIVE_CLEAR: "AUDIT_ARCHIVE_CLEAR",

  AUDIT_ARCHIVE_POST_REQUEST: "AUDIT_ARCHIVE_POST_REQUEST",
  AUDIT_ARCHIVE_POST_FAILURE: "AUDIT_ARCHIVE_POST_FAILURE",
  AUDIT_ARCHIVE_POST_SUCCESS: "AUDIT_ARCHIVE_POST_SUCCESS"
};

export const actionCreators = {
  clear: () => ({
    type: actionTypes.AUDIT_ARCHIVE_CLEAR
  }),
  itemSet: (auditArchive: any) => ({
    type: actionTypes.AUDIT_ARCHIVE_ITEM_SET,
    payload: { auditArchive }
  }),
  set: (auditArchive: Array<any>) => ({
    type: actionTypes.AUDIT_ARCHIVE_SET,
    payload: { auditArchive }
  }),
  getRequest: () => ({
    type: actionTypes.AUDIT_ARCHIVE_GET_REQUEST,
    [WAIT_FOR_ACTION]: actionTypes.AUDIT_ARCHIVE_GET_SUCCESS,
    [ERROR_ACTION]: actionTypes.AUDIT_ARCHIVE_GET_FAILURE
  }),
  getSuccess: (auditArchive: any) => ({
    type: actionTypes.AUDIT_ARCHIVE_GET_SUCCESS,
    payload: { auditArchive }
  }),
  getFailure: (error: Error) => ({
    type: actionTypes.AUDIT_ARCHIVE_GET_FAILURE,
    error
  }),
  merge: (auditArchive: Array<any>) => ({
    type: actionTypes.AUDIT_ARCHIVE_MERGE,
    payload: { auditArchive }
  }),

  postRequest: (auditArchive: any) => ({
    type: actionTypes.AUDIT_ARCHIVE_POST_REQUEST,
    payload: { auditArchive },
    [WAIT_FOR_ACTION]: actionTypes.AUDIT_ARCHIVE_POST_SUCCESS,
    [ERROR_ACTION]: actionTypes.AUDIT_ARCHIVE_POST_FAILURE
  }),
  postSuccess: (auditArchive: any) => ({
    type: actionTypes.AUDIT_ARCHIVE_POST_SUCCESS,
    payload: { auditArchive }
  }),
  postFailure: error => ({
    type: actionTypes.AUDIT_ARCHIVE_POST_FAILURE,
    error
  })
};

export default {
  create: actionCreators,
  type: actionTypes
};
